/**
 * Leader Pick Adapter (DKPLAT-354)
 *
 * Transforms admin preview data into LeaderPick component props for both
 * `player_leader` and `team_leader` question types. Preview is intentionally
 * pre-game: statValue is 0 for every candidate (live values only exist
 * once the customer is inside a contest with running fixture stats).
 */

import type { LeaderCandidate, LeaderPickProps } from '@low6-pickem/ui/components/LeaderPick';
import type { PreviewQuestionData } from '../types';

export function leaderPickAdapter(data: PreviewQuestionData): LeaderPickProps {
  const meta = data.questionMetadata?.leaderboard ?? {};
  // Prefer the explicit kind on the metadata; fall back to inferring from
  // the question type so older drafts without metadata still preview.
  const kind: 'player' | 'team' =
    meta.kind === 'team' || data.questionType === 'team_leader' ? 'team' : 'player';

  const options: LeaderCandidate[] = data.options.map((opt, idx) => {
    const externalId =
      kind === 'team' ? opt.option_team_external_id : opt.option_player_external_id;
    return {
      // Preview-only synthetic id when external id is missing. Real questions
      // always carry one, but a draft might not yet.
      id: externalId || `preview-${idx}`,
      name: opt.option_text_en || `Option ${idx + 1}`,
      imageUrl: opt.option_image_en || undefined,
      statValue: 0,
    };
  });

  return {
    options,
    statLabel: meta.statLabel || meta.statType || 'Stat',
    kind,
    selectedOptionId: undefined,
    onSelect: () => {},
    points: data.totalPoints,
    questionText: data.questionText || (kind === 'team' ? 'Pick a team' : 'Pick a player'),
    subtext: data.questionSubtext,
    disabled: true,
    questionId: 'preview',
  };
}
